<div class="modal-container">
  <div class="navigation-tabs">
    <button (click)="activeLoginModalTab = 'login'" class="tab" [ngClass]="getActiveTab('login')">LOGIN</button>
    <button
      (click)="activeLoginModalTab = 'signup'; forgotPasswordActive = false"
      class="tab"
      [ngClass]="getActiveTab('signup')"
    >
      SIGN UP
    </button>
  </div>
  @if (activeLoginModalTab === 'login' && !forgotPasswordActive) {
  <div class="modal-body">
    <div class="container-fluid">
      <form class="login-container" [class.forgot-password-active]="forgotPasswordActive">
        <mat-label for="email">Email</mat-label>
        <input matInput id="loginEmail" name="email" [(ngModel)]="loginData.username" />
        <mat-label for="password">Password</mat-label>
        <input
          matInput
          id="loginPassword"
          name="password"
          type="password"
          [(ngModel)]="loginData.password"
          (keyup.enter)="login()"
        />
        <a (click)="forgotPasswordActive = true">Forgot your password?</a>
      </form>
    </div>
    @if(loginError) {
      <div id="loginError" class="fas fa-ban text-danger">{{loginError}}</div>
    }
    <button id="loginBtn" type="button" class="white-submit login" (click)="login()">LOGIN</button>
  </div>
  } @if (activeLoginModalTab === 'login' && forgotPasswordActive) {
  <div class="modal-body">
    <div class="container-fluid">
      <form class="recovery-container slide-in-container" [class.forgot-password-active]="forgotPasswordActive">
        <div class="mat-label-compressable" for="recover-email">Enter the email associated with your account</div>
        <input matInput name="recover-email" [(ngModel)]="recoveryEmail" />
        <a (click)="forgotPasswordActive = false">Cancel</a>
      </form>
    </div>
    <button type="button" class="white-submit login" (click)="send()">SEND</button>
  </div>
  } @if (activeLoginModalTab === 'Noaccount') {
  <div class="modal-body">
    @if (!passwordInfo) {
    <div class="info-container1">
      <div class="column-header1">Not in the mood to create an account? Take it for a test drive.</div>
      <ul>
        <li>Get access to our test builder</li>
        <li>Will <i>not</i> be able to save work</li>
        <li>You cannot add to cart or pay for your test design</li>
        <li>Get access to our test builder</li>
      </ul>
    </div>
    }
  </div>
  } @if (activeLoginModalTab === 'signup') {
  <div class="modal-body">
    <div class="container-fluid requirements signup-container">
      <div class="form-container">
        <form class="login-container">
          <mat-label for="email">Email</mat-label>
          <input name="email" [(ngModel)]="registerData.username" matInput id="email" />
          <mat-label for="first-name">First Name</mat-label>
          <input
            autocomplete="first-name"
            name="first-name"
            [(ngModel)]="registerData.firstName"
            matInput
            id="first-name"
          />
          <mat-label for="last-name">Last Name</mat-label>
          <input
            autocomplete="last-name"
            name="last-name"
            [(ngModel)]="registerData.lastName"
            matInput
            id="last-name"
          />
          <mat-label for="password">Password</mat-label>
          <input
            name="password"
            (blur)="validatePassword(registerData.password)"
            [(ngModel)]="registerData.password"
            matInput
            id="password"
            type="password"
          />
          <mat-label for="confirm-password">Confirm Password</mat-label>
          <input
            name="confirm-password"
            (blur)="validatePassword(registerData.password)"
            [(ngModel)]="registerData.passwordConfirmation"
            matInput
            id="confirm-password"
            type="password"
          />
        </form>
      </div>
      @if (!passwordInfo) {
      <div class="info-container web-only">
        <div class="column-header">Create an account for access to:</div>
        <ul>
          <li>Unlimited design storage</li>
          <li>Purchase order history</li>
          <li>One-click purchasing</li>
          <li>Faster customer support</li>
        </ul>
      </div>
      }
      <div class="info-container2 requirements web-tab-only" id="password-requirements">
        <div class="column-header2">Password requirements:</div>
        <ul>
          <li id="length" class="validation" [ngClass]="{ valid: hasMinimumChars, invalid: !hasMinimumChars }">
            <span
              [ngClass]="{ 'fas fa-check text-success': hasMinimumChars, 'fas fa-ban text-danger': !hasMinimumChars }"
            >
              Be at least <strong>8 characters</strong>
            </span>
          </li>
          <li id="lowercase" class="validation" [ngClass]="{ valid: hasLowerLetter, invalid: !hasLowerLetter }">
            <span
              [ngClass]="{ 'fas fa-check text-success': hasLowerLetter, 'fas fa-ban text-danger': !hasLowerLetter }"
            >
              At least <strong>one letter</strong></span
            >
          </li>
          <li id="uppercase" class="validation" [ngClass]="{ valid: hasCapitalLetter, invalid: !hasCapitalLetter }">
            <span
              [ngClass]="{ 'fas fa-check text-success': hasCapitalLetter, 'fas fa-ban text-danger': !hasCapitalLetter }"
            >
              At least <strong>one capital letter</strong></span
            >
          </li>
          <li id="number" class="validation" [ngClass]="{ valid: hasNumber, invalid: !hasNumber }">
            <span [ngClass]="{ 'fas fa-check text-success': hasNumber, 'fas fa-ban text-danger': !hasNumber }">
              At least <strong>one number</strong></span
            >
          </li>
          <li id="special" class="validation" [ngClass]="{ valid: hasSpecialChar, invalid: !hasSpecialChar }">
            <span
              [ngClass]="{ 'fas fa-check text-success': hasSpecialChar, 'fas fa-ban text-danger': !hasSpecialChar }"
            >
              At least <strong>one special character (%^&$#)</strong></span
            >
          </li>
          <li id="password-match" class="validation" [ngClass]="{ valid: passwordsMatch, invalid: !passwordsMatch }">
            <span
              [ngClass]="{ 'fas fa-check text-success': passwordsMatch, 'fas fa-ban text-danger': !passwordsMatch }"
            >
              Passwords match</span
            >
          </li>
        </ul>
      </div>
      <!-- NOTE: there are two password requirement containers; any changes to one should be made to the other -->
    </div>
    <button type="button" class="white-submit signup" (click)="createUser()">SIGN UP</button>
    <div class="info-container requirements mobile-only">
      <div class="column-header">Password requirements:</div>
      <ul>
        <li id="length" class="validation" [ngClass]="{ valid: hasMinimumChars, invalid: !hasMinimumChars }">
          @if (hasMinimumChars) {
          <span><span class="fas fa-check text-success"></span></span>
          } @if (!hasMinimumChars) {
          <span><span class="fas fa-ban text-danger"></span></span>
          } Be at least <strong>8 characters</strong>
        </li>
        <li id="lowercase" class="validation" [ngClass]="{ valid: hasLowerLetter, invalid: !hasLowerLetter }">
          @if (hasLowerLetter) {
          <span><span class="fas fa-check text-success"></span></span>
          } @if (!hasLowerLetter) {
          <span><span class="fas fa-ban text-danger"></span></span>
          } At least <strong>one letter</strong>
        </li>
        <li id="uppercase" class="validation" [ngClass]="{ valid: hasCapitalLetter, invalid: !hasCapitalLetter }">
          @if (hasCapitalLetter) {
          <span><span class="fas fa-check text-success"></span></span>
          } @if (!hasCapitalLetter) {
          <span><span class="fas fa-ban text-danger"></span></span>
          } At least <strong>one capital letter</strong>
        </li>
        <li id="number" class="validation" [ngClass]="{ valid: hasNumber, invalid: !hasNumber }">
          @if (hasNumber) {
          <span><span class="fas fa-check text-success"></span></span>
          } @if (!hasNumber) {
          <span><span class="fas fa-ban text-danger"></span></span>
          } At least <strong>one number</strong>
        </li>
        <li id="special" class="validation" [ngClass]="{ valid: hasSpecialChar, invalid: !hasSpecialChar }">
          @if (hasSpecialChar) {
          <span><span class="fas fa-check text-success"></span></span>
          } @if (!hasSpecialChar) {
          <span><span class="fas fa-ban text-danger"></span></span>
          } At least <strong>one special character (%^&$#)</strong>
        </li>
        <li id="password-match" class="validation" [ngClass]="{ valid: passwordsMatch, invalid: !passwordsMatch }">
          @if (passwordsMatch) {
          <span><span class="fas fa-check text-success"></span></span>
          } @if (!passwordsMatch) {
          <span><span class="fas fa-ban text-danger"></span></span>
          } Passwords match
        </li>
      </ul>
    </div>
  </div>
  }
</div>
